export const calMaxWidth = () => {
  if (document.getElementsByClassName('editor-container').length) {
    const width = document.getElementsByClassName('editor-container')[0].clientWidth;
    if (width > 0) {
      return width;
    }
  }
  return window.innerWidth;
};

export const setTextareaHeight = (captionInputRefCurrent: HTMLTextAreaElement | null) => {
  if (captionInputRefCurrent) {
    captionInputRefCurrent.style.height = '1px';
    captionInputRefCurrent.style.height = captionInputRefCurrent.scrollHeight + 'px';
  }
};
